export type Specialty =
  | 'Nephrologist'
  | 'Cardiologist'
  | 'Endocrinologist'
  | 'PCP'

export interface AppState {
  quizAnswer: Specialty | null
  selectedSpecialty: Specialty | null
  groupName: string
  predictedBehavior: string | null
  predictedDriver: string | null
  predictedBarrier: string | null
  completedChapters: string[] // tracks which strategy chapters are done
  // Card fields — mapped to workshop objectives
  cardSegmentation: string // A. How to identify & prioritize this segment
  cardFeatures: string // B. Which features/arguments/data resonate
  cardMotivation: string // C. The right motivation to present
  cardQuoteForOthers: string // Share-back takeaway
}

export const SPECIALTY_COLORS: Record<Specialty, string> = {
  Nephrologist: '#E8871E',
  Cardiologist: '#C62828',
  Endocrinologist: '#C4B6B8',
  PCP: '#D4547A',
}

export const SPECIALTY_BG_COLORS: Record<Specialty, string> = {
  Nephrologist: 'bg-nephrologist',
  Cardiologist: 'bg-cardiologist',
  Endocrinologist: 'bg-endocrinologist',
  PCP: 'bg-pcp',
}

export const SPECIALTY_TEXT_COLORS: Record<Specialty, string> = {
  Nephrologist: 'text-nephrologist',
  Cardiologist: 'text-cardiologist',
  Endocrinologist: 'text-endocrinologist',
  PCP: 'text-pcp',
}

export const SPECIALTY_BORDER_COLORS: Record<Specialty, string> = {
  Nephrologist: 'border-nephrologist',
  Cardiologist: 'border-cardiologist',
  Endocrinologist: 'border-endocrinologist',
  PCP: 'border-pcp',
}

export interface StepProps {
  state: AppState
  updateState: (updates: Partial<AppState>) => void
  nextStep: () => void
  prevStep: () => void
  goToStep: (step: number) => void
  resetApp?: () => void
}
